import type { SelectOption } from '../commons/PageForm';

/** Misma constante en workflow.periodicidad, periodo.tipo y periodoActividad.tipoPeriodo. */
export type TipoPeriodo = 'MENSUAL' | 'ANUAL' | 'SEMESTRAL' | 'OTRO';

export const TIPO_PERIODO_VALUES: TipoPeriodo[] = ['MENSUAL', 'ANUAL', 'SEMESTRAL', 'OTRO'];

export const TIPO_PERIODO_LABEL: Record<TipoPeriodo, string> = {
  MENSUAL: 'Mensual',
  ANUAL: 'Anual',
  SEMESTRAL: 'Semestral',
  OTRO: 'Otro',
};

export const WORKFLOW_PERIODICIDAD_OPTIONS: SelectOption[] = TIPO_PERIODO_VALUES.map(value => ({
  value,
  label: TIPO_PERIODO_LABEL[value],
}));

/** Alias para formularios de periodo actividad / periodo. */
export const TIPO_PERIODO_OPTIONS = WORKFLOW_PERIODICIDAD_OPTIONS;

const LEGACY_TO_CANONICAL: Record<string, TipoPeriodo> = {
  ANUAL: 'ANUAL',
  MENSUAL: 'MENSUAL',
  SEMESTRAL: 'SEMESTRAL',
  OTRO: 'OTRO',
  anio: 'ANUAL',
  ANIO: 'ANUAL',
  mes: 'MENSUAL',
  MES: 'MENSUAL',
  semestre: 'SEMESTRAL',
  SEMESTRE: 'SEMESTRAL',
};

/** Normaliza valores legacy (`anio`, `mes`, …) al enum canónico. */
export function normalizeWorkflowPeriodicidad(raw?: string | null): string {
  const trimmed = raw?.trim();
  if (!trimmed) return '';
  return LEGACY_TO_CANONICAL[trimmed] ?? LEGACY_TO_CANONICAL[trimmed.toUpperCase()] ?? trimmed;
}

/** Misma constante que `periodo.tipo` y `periodoActividad.tipoPeriodo` (sin conversión intermedia). */
export function periodicidadToPeriodoTipo(periodicidad?: string | null): string | undefined {
  const norm = normalizeWorkflowPeriodicidad(periodicidad);
  if (norm) return norm;
  return trimmedOrUndefined(periodicidad);
}

export function formatWorkflowPeriodicidadLabel(raw?: string | null): string {
  const norm = normalizeWorkflowPeriodicidad(raw) as TipoPeriodo;
  if (norm && TIPO_PERIODO_LABEL[norm]) return TIPO_PERIODO_LABEL[norm];
  return raw?.trim() || '—';
}

export function formatTipoPeriodoLabel(raw?: string | null): string {
  return formatWorkflowPeriodicidadLabel(raw);
}

function trimmedOrUndefined(value?: string | null): string | undefined {
  const trimmed = value?.trim();
  return trimmed || undefined;
}
